export let percentFormat = new Intl.NumberFormat("en-US", {
  style: "percent",
  maximumFractionDigits: 0
});

export let precisePercentFormat = new Intl.NumberFormat("en-US", {
  style: "percent",
  maximumFractionDigits: 1
});

export let dollarFormat = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0
});

export let bigDollarFormat = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
  maximumSignificantDigits: 3,
  notation: "compact",
  compactDisplay: "short"
});

export let preciseDollarFormat = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2
});

export let normalFormat = new Intl.NumberFormat("en-US");

export let roundFormat = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 0
});

export let preciseFormat = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 1,
  minimumFractionDigits: 1
});

export let ratioFormat = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2
});
